import { pluck, distinctUntilChanged, map } from 'rxjs/operators';

/**
 * @param {Observable<playback-web-player.Frame>} frameUpdate$
 * @return {Observable<boolean>}
 */

const createUiHiddenStream = frameUpdate$ =>
    frameUpdate$
        .pipe(
            pluck('areControlsActive'),
            map(areControlsActive => !areControlsActive),
            distinctUntilChanged()
        );

export default createUiHiddenStream;
